<template>
  <div class="flex flex-col items-center text-center">
    <div class="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500">
      <Lock :size="28" />
    </div>
    <h2 class="text-xl font-bold text-gray-900">
      {{ $t('COMMON.ACCESS_BLOCKED_TITLE') }}
    </h2>
    <p class="mt-2 text-sm text-gray-600">
      {{ $t('COMMON.ACCESS_BLOCKED_MESSAGE') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import {
  Lock,
} from "@lucide/vue";
</script>
